import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bank-report',
  templateUrl: './bank-report.component.html',
  styleUrls: ['./bank-report.component.css']
})
export class BankReportComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
